import { App } from 'vue'
import Catalog from './Catalog.vue'
import Card from './Card.vue'
import Details from './Details.vue'
import VacancyModalContainer from './VacancyModalContainer.vue'
import ThankYouModalContainer from './ThankYouModalContainer.vue'

const register = (app: App<Element>): void => {
  app
    .component('vacancy-catalog', Catalog)
    .component('vacancy-card', Card)
    .component('vacancy-details', Details)
    .component('Vacancies/VacancyModalContainer', VacancyModalContainer)
    .component('Vacancies/ThankYouModalContainer', ThankYouModalContainer)
}

export default {
  register,
}
